import React from 'react';
import './Results.css';

const Results = () => {
  const results = [
    {
      number: '50+',
      unit: '名',
      title: 'エンジニア採用',
      description: '年間50名以上の採用に貢献',
      color: 'primary'
    },
    {
      number: '500+',
      unit: '件',
      title: '面談・支援実績',
      description: 'エンジニアキャリア支援',
      color: 'secondary'
    },
    {
      number: '1.2',
      unit: '億円',
      title: 'SES/SI営業売上',
      description: '年間売上実績',
      color: 'accent'
    },
    {
      number: '4,300',
      unit: '万円',
      title: '新規案件受注',
      description: '年間新規売上',
      color: 'tertiary'
    }
  ];

  return (
    <section id="results" className="results">
      <div className="container">
        <div className="results__header animate-on-scroll">
          <h2 className="results__title">
            実績で証明する<br />
            実行力
          </h2>
          <p className="results__subtitle">
            現場で積み上げた、確かな成果
          </p>
        </div>

        <div className="results__grid">
          {results.map((result, index) => (
            <div 
              key={index}
              className={`results__card results__card--${result.color} animate-on-scroll`}
              style={{ animationDelay: `${0.1 + index * 0.1}s` }}
            >
              <div className="results__card-background"></div>
              <div className="results__card-content">
                <div className="results__number">
                  <span className="results__number-value">{result.number}</span>
                  <span className="results__number-unit">{result.unit}</span>
                </div>
                <h3 className="results__card-title">{result.title}</h3>
                <p className="results__card-description">{result.description}</p>
              </div>
              <div className="results__card-decoration"></div>
            </div>
          ))}
        </div>

        <div className="results__venn animate-on-scroll" style={{ animationDelay: '0.5s' }}>
          <div className="results__venn-container">
            <div className="results__venn-circle results__venn-circle--1">
              <span>採用</span>
            </div>
            <div className="results__venn-circle results__venn-circle--2">
              <span>営業</span>
            </div>
            <div className="results__venn-circle results__venn-circle--3">
              <span>育成</span>
            </div>
            <div className="results__venn-center">
              <strong>横断実行</strong>
            </div>
          </div>
          <p className="results__venn-text">
            営業・採用・育成を<strong>実務で回した経験</strong>が<br className="mobile-break" />
            経営者の課題を具体的に解決します
          </p>
        </div>
      </div>
    </section>
  );
};

export default Results;